// src/vendor/VendorDashboard.jsx
import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Select, MenuItem } from '@mui/material';
import { collection, query, where, onSnapshot, doc, getDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { db } from '../firebase';

export default function VendorDashboard() {
  const auth = getAuth();
  const [vendorOrders, setVendorOrders] = useState([]);
  const [filter, setFilter] = useState('All');

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) return;

    const q = query(
      collection(db, 'workOrders'),
      where('assignedVendorId', '==', user.uid)
    );

    const unsub = onSnapshot(q, snapshot => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setVendorOrders(data);
    });

    return () => unsub();
  }, []);

  const filteredOrders = vendorOrders.filter(order => {
    if (filter === 'All') return true;
    return order.type === filter;
  });

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>Vendor ledger</Typography>
      <Paper sx={{ mb: 2, p: 2 }}>
        <Select
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          displayEmpty
        >
          <MenuItem value="All">All transaction types</MenuItem>
          <MenuItem value="Maintenance request">Maintenance request</MenuItem>
        </Select>
      </Paper>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>DATE</TableCell>
              <TableCell>NUMBER</TableCell>
              <TableCell>REF. NO.</TableCell>
              <TableCell>TYPE</TableCell>
              <TableCell>PROPERTY</TableCell>
              <TableCell>ACCOUNT</TableCell>
              <TableCell>MEMO</TableCell>
              <TableCell>AMOUNT</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredOrders.map((order) => (
              <TableRow key={order.id}>
                <TableCell>
                  {order.createdAt?.toDate ? order.createdAt.toDate().toLocaleDateString() : '—'}
                </TableCell>
                <TableCell>{order.id.slice(0, 6).toUpperCase()}</TableCell>
                <TableCell>{order.workOrderNumber || '—'}</TableCell>
                <TableCell>{order.type}</TableCell>
                <TableCell>{order.property}</TableCell>
                <TableCell>{order.account || '—'}</TableCell>
                <TableCell>{order.memo || order.subject}</TableCell>
                <TableCell>{order.amount ? `$${order.amount.toFixed(2)}` : '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}